import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-50 animate-fade-in" data-id="element-327">
      <a href="tel:08000554969" className="flex items-center gap-2 bg-[#E8956B] text-white px-6 py-4 rounded-full font-semibold hover:bg-[#D67D54] transition-all shadow-xl hover:shadow-2xl" data-id="element-328">
        <Phone size={20} data-id="element-329" />
        <span className="hidden sm:inline" data-id="element-330">Request a Callout</span>
      </a>
    </div>;
}